export const LOGIN_URL = process.env.NODE_ENV === 'development' ? 'https://login.web.money/better/GateKeeper.aspx' : 'https://login.web.money/GateKeeper.aspx'
export const SIGN_ON_URL = process.env.NODE_ENV === 'development' ? 'https://login.web.money/better/GateKeeper/SingleSignOn.js' : 'https://login.web.money/GateKeeper/SingleSignOn.js'

export const FAIL_COUNT = 5

export const maxFilesizeMb = 50

export const bytesInMb = 1048576
